export const organizationSchema = {
  '@type': 'Organization',
  name: '春色影视',
  url: 'https://chunseys.com',
  description: '春色影视是一个致力于为观众提供高品质在线观影体验的影视平台，提供免费、高清、流畅的影视播放服务。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-6666',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
    email: 'contact@chunseys.com',
  },
};

export const websiteSchema = {
  '@type': 'WebSite',
  name: '春色影视',
  url: 'https://chunseys.com',
  description: '春色影视确保不缓冲流畅播放，高清免费在线观看，免费不收费，秒开无卡顿极速影视体验，电影电视剧全集实时更新。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://chunseys.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export function getWebPageSchema(title: string, description: string, url: string) {
  return {
    '@type': 'WebPage',
    name: title,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: '春色影视',
      url: 'https://chunseys.com',
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url?: string }[]) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url || undefined,
    })),
  };
}

export function getArticleSchema(movie: {
  title: string;
  description: string;
  image: string;
  datePublished: string;
  dateModified: string;
  url: string;
}) {
  return {
    '@type': 'Article',
    headline: movie.title,
    description: movie.description,
    image: movie.image,
    datePublished: movie.datePublished,
    dateModified: movie.dateModified,
    url: movie.url,
    author: {
      '@type': 'Organization',
      name: '春色影视',
    },
    publisher: {
      '@type': 'Organization',
      name: '春色影视',
    },
  };
}

export function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}